var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('div',{staticClass:"flex justify-center mb-5"},[_c('router-link',{attrs:{"to":_vm.url}},[_c('a',{staticClass:"font-semibold text-gray-700 text-sm tracking-wider hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150",attrs:{"href":"#"}},[_vm._v(" Admin Chat (without video) ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }